import { render, staticRenderFns } from "./ResetPassword1.vue?vue&type=template&id=08f14be8&scoped=true&"
import script from "./ResetPassword1.vue?vue&type=script&lang=js&"
export * from "./ResetPassword1.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword1.vue?vue&type=style&index=0&id=08f14be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f14be8",
  null
  
)

export default component.exports